import React from 'react'
import { Form, Input, Button, DatePicker, message, Radio } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

const { TextArea } = Input

function AddCustomerForm({ onSubmit, onCancel }) {
  const [form] = Form.useForm()
  const [loading, setLoading] = React.useState(false)

  const handleSubmit = async (values) => {
    setLoading(true)
    
    try {
      const customerData = {
        ...values,
        appointment_time: values.appointment_time ? values.appointment_time.format('YYYY-MM-DD HH:mm') : ''
      }
      
      await onSubmit(customerData)
      form.resetFields()
    } catch (error) {
      message.error('提交失败')
    }
    
    setLoading(false)
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      className="add-customer-form"
    >
      <Form.Item
        name="customer_type"
        label="客户类型"
        rules={[{ required: true, message: '请选择客户类型' }]}
        initialValue="walk_in"
      >
        <Radio.Group>
          <Radio value="walk_in">当面推销客户</Radio>
          <Radio value="online">线上预约客户</Radio>
        </Radio.Group>
      </Form.Item>

      <div className="form-grid">
        <Form.Item
          name="name"
          label="客户姓名"
          rules={[{ required: true, message: '请输入客户姓名' }]}
          className="form-item"
        >
          <Input placeholder="请输入客户姓名" size="large" />
        </Form.Item>

        <Form.Item
          name="phone"
          label="联系电话"
          rules={[
            { required: true, message: '请输入联系电话' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码' }
          ]}
          className="form-item"
        >
          <Input placeholder="请输入手机号码" size="large" />
        </Form.Item>
      </div>

      <Form.Item
        name="address"
        label="客户地址"
        rules={[{ required: true, message: '请输入客户地址' }]}
      >
        <Input placeholder="请输入详细地址" size="large" />
      </Form.Item>

      <div className="form-grid">
        <Form.Item
          name="appointment_time"
          label="预约时间"
          className="form-item"
        >
          <DatePicker 
            showTime 
            format="YYYY-MM-DD HH:mm"
            placeholder="选择预约时间"
            style={{ width: '100%' }}
            size="large"
            showNow={false}
            disabledDate={(current) => {
              return current && current < Date.now() - 24 * 60 * 60 * 1000;
            }}
          />
        </Form.Item>

        <Form.Item
          name="package_type"
          label="套餐类型"
          rules={[{ required: true, message: '请输入套餐类型' }]}
          className="form-item"
        >
          <Input placeholder="请输入套餐类型" size="large" />
        </Form.Item>
      </div>

      <Form.Item
        name="remark"
        label="备注信息"
      >
        <TextArea 
          placeholder="请输入备注信息"
          rows={3}
          size="large"
        />
      </Form.Item>



      <div className="form-actions">
        <Button onClick={onCancel} size="large">
          取消
        </Button>
        <Button 
          type="primary" 
          htmlType="submit" 
          loading={loading}
          size="large"
          icon={<PlusOutlined />}
        >
          添加客户
        </Button>
      </div>
    </Form>
  )
}

export default AddCustomerForm